import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { push } from "react-router-redux";
import DatePicker from "../../components/DatePicker";
import { authOnLogout } from "../../modules/auth/AuthActions";

import {
  Menu,
  Container,
  Dropdown,
  Button,
  Header,
  Grid,
  Sidebar,
  Segment,
  Image,
  Icon,
} from "semantic-ui-react";
import { getUrl } from "../../constants/constants";

class TopHeader extends React.Component {
  render() {
    let { filters, dispatch, auth } = this.props;
    // var type = filters ? filters.user_type : null;
    var type = filters ? filters.type : null;
    var user_type = filters ? filters.user_type : null;
    var brand = auth ? (auth.brand ? auth.brand.toLowerCase() : "") : "";

    console.log("brand name", auth);
    // let getUrl = () => {
    //   switch (type) {
    //     case "operator":
    //       return "/dashboard";
    //     case "restaurant":
    //       return "/dashboard/restaurant";
    //     case "retail":
    //       if (user_type === "ke_account") return "/dashboard/sales";
    //       else return "/dashboard/sales";
    //     default:
    //       return "/dashboard/sales";
    //   }
    // };

    const getTopHeader = () => {
      switch (brand) {
        case "shell helix":
          return (
            <Menu fixed="top" style={styles.topHeaderHelix}>
              <div style={styles.title}>
                <div style={styles.logoMain}>
                  <img src="/shell_helix_logo.png" />
                </div>
              </div>

              <Menu.Menu position="right">
                <Dropdown icon="bars" style={styles.topMenu}>
                  <Dropdown.Menu style={styles.dropmain}>
                    <Dropdown.Item onClick={this.props.authOnLogout}>
                      <img style={styles.iconImg} src="/logout_icon.png" />
                      <span style={styles.dropinner}>Logout</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Menu>
              <div style={styles.shellLogo}>
                <img src="/oscar_logo.png" />
              </div>
            </Menu>
          );

        case "shell select":
          return (
            <Menu fixed="top" style={styles.topHeader}>
              <div style={styles.title}>
                <div style={styles.logoMain}>
                  <img src="/shellselect_logo.png" />
                </div>
              </div>

              <Menu.Menu position="right">
                <Dropdown icon="bars" style={styles.topMenu}>
                  <Dropdown.Menu style={styles.dropmain}>
                    {filters ? (
                      filters.has_reports ? (
                        <Dropdown.Item>
                          <Link to="/dashboard/reports">
                            <img style={styles.iconImg} src="/reporting.png" />
                            <span style={styles.dropinner}>Reporting</span>
                          </Link>
                        </Dropdown.Item>
                      ) : null
                    ) : null}
                    <Dropdown.Item>
                      <Link to={getUrl(type, user_type)}>
                        <img style={styles.iconImg} src="/customer_icon.png" />
                        <span style={styles.dropinner}>Dashboard</span>
                      </Link>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={this.props.authOnLogout}>
                      <img style={styles.iconImg} src="/logout_icon.png" />
                      <span style={styles.dropinner}>Logout</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Menu>
              <div style={styles.shellLogo}>
                <img src="/oscar_logo.png" />
              </div>
            </Menu>
          );

        case "shell delicafe":
          return (
            <Menu fixed="top" style={styles.topHeader}>
              <div style={styles.title}>
                <div style={styles.logoMain}>
                  <img src="/shellselect_logo.png" />
                </div>
              </div>

              <Menu.Menu position="right">
                <Dropdown icon="bars" style={styles.topMenu}>
                  <Dropdown.Menu style={styles.dropmain}>
                    {filters ? (
                      filters.has_reports ? (
                        <Dropdown.Item>
                          <Link to="/dashboard/reports">
                            <img style={styles.iconImg} src="/reporting.png" />
                            <span style={styles.dropinner}>Reporting</span>
                          </Link>
                        </Dropdown.Item>
                      ) : null
                    ) : null}
                    <Dropdown.Item>
                      <Link to={getUrl(type, user_type)}>
                        <img style={styles.iconImg} src="/customer_icon.png" />
                        <span style={styles.dropinner}>Dashboard</span>
                      </Link>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={this.props.authOnLogout}>
                      <img style={styles.iconImg} src="/logout_icon.png" />
                      <span style={styles.dropinner}>Logout</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Menu>
              <div style={styles.shellLogo}>
                <img src="/oscar_logo.png" />
              </div>
            </Menu>
          );

        case "bonjour":
          return (
            <Menu fixed="top" style={styles.topHeaderTotal}>
              <div style={styles.title}>
                <div style={styles.logoMain}>
                  <img src="/totalLogo.png" />
                </div>
              </div>

              <Menu.Menu position="right">
                <Dropdown icon="bars" style={styles.topMenu}>
                  <Dropdown.Menu style={styles.dropmain}>
                    {filters ? (
                      filters.has_reports ? (
                        <Dropdown.Item>
                          <Link to="/dashboard/reports">
                            <img style={styles.iconImg} src="/reporting.png" />
                            <span style={styles.dropinner}>Reporting</span>
                          </Link>
                        </Dropdown.Item>
                      ) : null
                    ) : null}
                    <Dropdown.Item>
                      <Link to={getUrl(type, user_type)}>
                        <img style={styles.iconImg} src="/customer_icon.png" />
                        <span style={styles.dropinner}>Dashboard</span>
                      </Link>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={this.props.authOnLogout}>
                      <img style={styles.iconImg} src="/logout_icon.png" />
                      <span style={styles.dropinner}>Logout</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Menu>
              <div style={styles.shellLogo}>
                <img src="/oscar_logo.png" />
              </div>
            </Menu>
          );

        case "go | aramco":
          return (
            /*<Menu fixed="top" class="aramcoHeader"> */
            <Menu
              fixed="top"
              class="aramcoHeader"
              /* style={styles.topHeaderHelix} */
            >
              <div className="aramcoHeaderLeft">
                {/* <img src="/shell_helix_logo.png" /> */}
                <img src="/go_aramco_logo_light.png" />
              </div>

              <div class="aramcoHeaderRight">
                <div class="shellLogo">
                  <img src="/oscar_logo.png" />
                </div>
                <Menu.Menu className="topmenuBox" position="right">
                  <Dropdown icon="bars">
                    <Dropdown.Menu style={styles.dropmain}>
                      <Dropdown.Item onClick={this.props.authOnLogout}>
                        <img style={styles.iconImg} src="/logout_icon.png" />
                        <span style={styles.dropinner}>Logout</span>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Menu.Menu>
              </div>
            </Menu>
          );

        default:
          return (
            <Menu
              fixed="top"
              style={{
                ...styles.topHeader,
                backgroundImage: "url(/top_bg.png)",
              }}
            >
              <div style={styles.title}>
                <div style={styles.logoOperator}>
                  <img src="/oscar_logo_operator.png" />
                </div>
              </div>
              <Menu.Menu position="right">
                <Dropdown icon="bars" style={styles.topMenu}>
                  <Dropdown.Menu style={styles.dropmain}>
                    {filters ? (
                      filters.has_reports ? (
                        <Dropdown.Item>
                          <Link to="/dashboard/reports">
                            <img style={styles.iconImg} src="/reporting.png" />
                            <span style={styles.dropinner}>Reporting</span>
                          </Link>
                        </Dropdown.Item>
                      ) : null
                    ) : null}
                    <Dropdown.Item>
                      <Link to={getUrl(type, user_type)}>
                        <img style={styles.iconImg} src="/customer_icon.png" />
                        <span style={styles.dropinner}>Dashboard</span>
                      </Link>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={this.props.authOnLogout}>
                      <img style={styles.iconImg} src="/logout_icon.png" />
                      <span style={styles.dropinner}>Logout</span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Menu.Menu>
            </Menu>
          );
      }
    };

    return getTopHeader();
  }
}

const styles = {
  dropmain: {
    backgroundColor: "rgba(0,0,0,0.92)",
    color: "#fff",
    borderRadius: 0,
    marginTop: 2,
  },
  dropinner: {
    color: "#fff",
    borderBottomWidth: 1,
    borderBottomColor: "#af2d2d",
  },
  iconDrop: {
    fontSize: 15,
    paddingBottom: 25,
    color: "#fff",
  },
  topMenu: {
    color: "#fff",
    borderWidth: 0,
    borderLeftWidth: 0,
    shadowOpacity: 0,
    paddingTop: 16,
    paddingRight: 8,
  },
  topHeader: {
    backgroundImage: "url(/shell_bg.png)",
    backgroundSize: "cover",
    //backgroundColor: '#652d92',
    color: "white",
    paddingTop: 5,
    height: 60,
    // borderBottomWidth:2,
    // borderBottomColor: '#cb55f8',
  },
  topHeaderHelix: {
    backgroundImage: "url(/shell_bg_helix.png)",
    backgroundSize: "cover",
    // backgroundColor: '#DF0C36 !important',
    color: "white",
    paddingTop: 5,
    height: 60,
    // borderBottomWidth:2,
    // borderBottomColor: '#cb55f8',
  },
  topHeaderTotal: {
    // backgroundImage: "url(/shell_bg_helix.png)",
    backgroundSize: "cover",
    backgroundColor: "#DF0C36",
    color: "white",
    paddingTop: 5,
    height: 60,
    // borderBottomWidth:2,
    // borderBottomColor: '#cb55f8',
  },
  shellLogo: {
    position: "absolute",
    right: "0",
    marginRight: 40,
    marginTop: 5,
  },
  logoOperator: {
    paddingTop: 10,
    paddingLeft: 9,
  },
  logoMain: {
    paddingTop: 5,
    paddingLeft: 9,
  },
  iconImg: {
    top: 5,
    position: "relative",
    marginLeft: -5,
    marginRight: 10,
  },
  iconImglocation: {
    top: 5,
    position: "relative",
  },
};

export default connect((state) => {
  return state;
})(TopHeader);
// null,
// { authOnLogout }



// WEBPACK FOOTER //
// ./src/components/TopHeader/index.js